/*
 *
 * LoginPage reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  CHANGE_LOGIN_FORM,
  CHANGE_SIGNUP_FORM,
  OTP_REQUEST_SUCCESS,
  CHANGE_FORGOT_FORM,
  FORGOT_OTP_SUCCESS,
  OTP_SUBMIT_SUCCESS,
  CHANGE_SET_PASSWORD_FORM,
  SET_PASSWORD_SUCCESS,
  SHOW_LOGIN_FORM,
  // LOGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
} from './constants';

export const initialState = fromJS({
  form: { username: '', password: '' },
  loggingIn: false,
  signUpform: {},
  otpRequestSuccess: {},
  forgotForm: {},
  otpSent: false,
  otpSubmit: false,
  setPasswordForm: {},
  setPasswordSubmit: false,
  isShowLogin: false,
  isLoginSuccess: false,
});

function loginPageReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    case SHOW_LOGIN_FORM:
      return state
        .set('isShowLogin', payload); /** @param {*boolean} payload */
    case CHANGE_LOGIN_FORM:
      return state
        .setIn(['form', action.payload.prop], action.payload.value);
    case CHANGE_SIGNUP_FORM:
      return state
        .setIn(['signUpform', action.payload.prop], action.payload.value);
    case OTP_REQUEST_SUCCESS:
      return state
        .set('otpRequestSuccess', fromJS(payload))
        .set('otpSent', true); /** @arg {*otpSent} @default true */
    case CHANGE_FORGOT_FORM:
      return state
        .setIn(['forgotForm', action.payload.prop], action.payload.value);
    case FORGOT_OTP_SUCCESS:
      return state
        .set('otpSent', payload);
    case OTP_SUBMIT_SUCCESS:
      return state
        .set('otpSubmit', payload);
    case CHANGE_SET_PASSWORD_FORM:
      return state
        .setIn(['setPasswordForm', action.payload.prop], action.payload.value);
    case SET_PASSWORD_SUCCESS:
      return state
        .set('setPasswordSubmit', payload);
    case LOGIN_SUCCESS:
      return state.set('isLoginSuccess', true);
    case LOGIN_ERROR:
      return state.set('isLoginSuccess', false);
    default:
      return state;
  }
}

export default loginPageReducer;



// WEBPACK FOOTER //
// client/containers/LoginPage/reducer.js